module.exports = __webpack_public_path__ + "img/product_30.817d5bc.jpg";